import React, {Component} from 'react';
import PropTypes from "prop-types";
import {withStyles} from '@material-ui/core/styles/index';
import {Button, FormControl, Icon, Input, InputLabel} from '@material-ui/core';

class UecareYesNoButton extends Component {

    static propTypes = {
        id: PropTypes.string,
        icon: PropTypes.string,
        name: PropTypes.string,
        label: PropTypes.string.isRequired,
        disabled: PropTypes.bool,
        className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        value: PropTypes.string,
        yesButton: PropTypes.object.isRequired,
        noButton: PropTypes.shape({
            color: PropTypes.string,
            disabled: PropTypes.bool,
            onClick: PropTypes.func,
            label: PropTypes.string,
        })
    };

    render() {
        const {classes} = this.props;

        return (
            <div className="flex">
                <div className="min-w-48 pt-20">
                    <Icon color="action">{this.props.icon}</Icon>
                </div>

                <FormControl className={this.props.className} fullWidth>
                    <InputLabel> {this.props.label} </InputLabel>
                    <Input id={this.props.id}
                           name={this.props.name}
                           value={this.props.value} disabled/>
                    <div>
                        <Button variant="contained"
                                disabled={this.props.yesButton.disabled}
                                color={this.props.yesButton.color}
                                className={classes.button}
                                onClick={this.props.yesButton.onClick}>
                            {this.props.yesButton.label}
                        </Button>
                        <Button variant="contained"
                                disabled={this.props.noButton.disabled}
                                color={this.props.noButton.color}
                                className={classes.button}
                                onClick={this.props.noButton.onClick}>
                            {this.props.noButton.label}
                        </Button>
                    </div>
                </FormControl>
            </div>
        );
    }
}


const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },
});

export default withStyles(styles, {withTheme: true})(UecareYesNoButton);



// WEBPACK FOOTER //
// ./src/components/UecareYesNoButton.js